var module;
// LICENSE_CODE ZON
'use strict'; /*jslint react:true, es6:true, node:true*/
(function () {
  var is_node = typeof module == 'object' && module.exports;
  if (is_node) ;else ;
  // Keep API backward-compatible: consumers call get_exe_link(opt)
  // internal callers may pass (www_util, hopt, guess_fn, versions, opt)
  define(['hola_opt', '/www/hola/pub/util.js', 'svc_versions', '/www/hola/pub/client_hints_global.ts', '/www/hola/pub/install_constants.js'], (hopt, www_util, versions, client_hints, install_constants) => {
    var E = {};
    var guess_fn = client_hints && client_hints.guess_os_and_version;
    var hola_apps = install_constants && install_constants.hola_apps;
    E.get_filename = function () {
      // accept either (opt) or (www_util, hopt, guess_fn, versions, opt)
      var opt = arguments.length > 1 ? arguments[arguments.length - 1] : arguments[0];
      var g = guess_fn || (() => ({}));
      return www_util.get_exe_filename(hopt, g(), versions, opt).replace(/\?.*/, '');
    };
    E.get_exe_link = function () {
      var opt = arguments.length > 1 ? arguments[arguments.length - 1] : arguments[0];
      var g = guess_fn || (() => ({}));
      return www_util.get_exe_link(hopt, g(), versions, opt);
    };
    E.get_link = function () {
      // Accept object opt as sole arg, or multi-arg where last is opt
      var opt = arguments.length > 1 ? arguments[arguments.length - 1] : arguments[0];
      var has_svc = opt.has_svc,
        svc_info = opt.svc_info,
        item = opt.item;
      var _ref = item || {},
        name = _ref.name,
        href = _ref.href;
      if (['mac_beta', 'mac', 'windows'].includes(name)) {
        return E.get_exe_link({
          has_svc,
          svc_info,
          os: name == 'windows' ? 'windows' : 'macos'
        });
      }
      return href ? href : `/download/${name}`;
    };
    E.get_link_review = function (id) {
      if (id == 'amazon') {
        return 'https://www.amazon.com/Hola-Free-VPN-Proxy-Unblocker/dp/' + 'B08XBVQ81K/ref=cm_cr_arp_d_product_top?ie=UTF8';
      }
      var obj = (hola_apps && hola_apps.browsers || []).find(_b => _b.name == id);
      return obj ? obj.href : 'https://hola.org';
    };
    E.open_link = function (id) {
      if (typeof window != 'undefined') window.open(E.get_link_review(id));
    };
    return E;
  });
})();